export default __webpack_public_path__ + "static/FbTestimonial4-4042c8877c13e734d885bba06686c4ec.jpeg";